<mat-menu class="mat-menu" #menu>
  <button mat-menu-item class="screenshot-mode" (click)="toggleSSMode()">
    {{ ssMode ? 'Exit screenshot mode' : 'Enter screenshot mode' }}
  </button>
  <button mat-menu-item (click)="$event.stopPropagation()" class="size-input">
    <label>width</label>
    <input
      #width
      mapInput
      type="number"
      [value]="3840"
      (change)="setWidth(width.value)"
      (click)="$event.stopPropagation()"
      [class.badSize]="disabled"
    />
  </button>
  <button mat-menu-item (click)="$event.stopPropagation()" class="size-input">
    <label>height</label>
    <input
      #height
      mapInput
      type="number"
      [value]="2610"
      (change)="setHeight(height.value)"
      (click)="$event.stopPropagation()"
      [class.badSize]="disabled"
    />
  </button>
  <button mat-menu-item (click)="$event.stopPropagation()">
    <mat-radio-group [(ngModel)]="fitting" class="fitting-radios">
      <mat-radio-button *ngFor="let fitting of fittings" [value]="fitting"
        >{{ fitting }}
      </mat-radio-button>
    </mat-radio-group>
  </button>
  <button
    mat-menu-item
    [disabled]="disabled"
    class="make-picture"
    (click)="makePicture()"
  >
    {{ buttonText() }}
  </button>
</mat-menu>
<app-menu-toggle
  [matMenuTriggerFor]="menu"
  [active]="ssMode"
  tooltip="Screenshot options: enter screenshot mode or save a picture from the current view"
  icon="ss-mode"
>
</app-menu-toggle>
<div>
  <canvas hidden id="screenshotCanvas"></canvas>
</div>
